<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title primary-title>
        <v-btn @click="ClearCart" icon color="error">
          <v-icon>fas fa-trash-alt</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ `${SellType.toUpperCase()} CART LIST` }}
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="closeView">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :mobile-breakpoint="200"
          :headers="CartHeader"
          :items="getCarts"
          :item-class="item => RemainItem(item)"
        >
          <template #top>
            <v-toolbar
              flat
              dark
              :color="SellType == 'retail' ? 'error' : 'primary'"
            >
              <v-spacer></v-spacer>
              <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
            </v-toolbar>
          </template>
          <template v-slot:[`item.InvName`]="{ item }">
            <BulkQty
              :SellType="SellType"
              :RemainQty="RemainQty(item)"
              :item="item"
            ></BulkQty>
          </template>
          <template v-slot:[`item.qty`]="{ item }">
            <div class="d-inline">
              <span>
                <v-btn class="d-print-none" small icon color="primary">
                  <v-icon @click="decrease(item)" small>fas fa-minus</v-icon>
                </v-btn>
              </span>
              <strong>{{ item.qty }}</strong>
              <span>
                <v-btn
                  @click="increase(item)"
                  class="d-print-none"
                  small
                  icon
                  color="primary"
                >
                  <v-icon small>fas fa-plus</v-icon>
                </v-btn>
              </span>
            </div>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price.toLocaleString() }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <strong class="mr-2"> QTY: {{ TotalQtyInCart }} </strong>
        <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
        <v-spacer></v-spacer>

        <!-- <paymentForm
          v-if="TotalQtyInCart"
          :StoreInfo="UsersToken"
          :SellType="SellType"
          :TotalPriceInCart="TotalPriceInCart"
        ></paymentForm> -->
        <TransferTo
          v-if="TotalQtyInCart"
          :StoreInfo="UsersToken"
          :SellType="SellType"
          :TotalPriceInCart="TotalPriceInCart"
        ></TransferTo>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    // paymentForm: () => import("../Sales/PaymentForm"),
    BulkQty: () => import("../Sales/bulkQty"),
    TransferTo: () => import("./transferTo"),
  },
  data() {
    return {
      dialog: false,
      CartHeader: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
          //   class: "green darken-3 white--text"
        },
        {
          text: "QTY",
          value: "qty",
          //   class: "green darken-3 white--text"
        },

        {
          text: "PRICE",
          value: "price",
          //   class: "green darken-3 white--text"
        },
      ],
    };
  },
  watch: {
    TotalQtyInCart(v) {
      if (v == 0 && this.dialog == true) this.dialog = false;
    },
  },
  computed: {
    ...mapGetters(["getGroupedProducts", "getCarts", "UsersToken"]),
    SellType() {
      let isRetailCart = this.getCarts.every(item => item.retail === true);
      return isRetailCart ? "retail" : "wholesale";
    },
    TotalQtyInCart() {
      return this.getCarts.reduce((total, item) => {
        return (total += item.qty);
      }, 0);
    },

    TotalPriceInCart() {
      return this.getCarts.reduce((total, item) => {
        return (total += item.qty * item.price);
      }, 0);
    },
  },
  methods: {
    ClearCart() {
      this.$store.commit("RESET_CART");
    },
    closeView() {
      this.dialog = false;
    },
    RemainQty(item) {
      return this.getGroupedProducts.find(prod => prod.product == item.product);
    },
    RemainItem(item) {
      // console.log(item);
      let { qty, UnitQty } = this.getGroupedProducts.find(
        prod => item.product == prod.product
      );
      // console.log(qty);
      if (this.SellType == "retail") qty = qty * UnitQty;

      const remain = qty - item.qty;
      if (remain == 0) return "yellow darken-2 black--text";
      else if (remain < 0) return "error darken-1 white--text";
      else return "";
    },
    increase(item) {
      this.$store.commit("INCREASE_DECREASE_CART", {
        item,
        retail: this.SellType == "retail" ? true : false,
      });
    },
    decrease(item) {
      this.$store.commit("INCREASE_DECREASE_CART", { item, type: "dec" });
    },
  },
};
</script>
